export default "__VITE_ASSET__D3SXYou7__"